import { Input } from '@/components/Input';
import { selectFirstName, selectLastName, setLastName } from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { setDemoMode } from '@/utils/setDemoMode';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'LastName';

export function LastName({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectLastName);
    const firstName = useAppSelector(selectFirstName);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        if (typeof value === 'boolean') return;
        if (value === currentState) return;
        if (value?.length > 12) return;

        setDemoMode(firstName ?? '', value);

        dispatch(setLastName(value));
    }

    // ***** Render *****
    return (
        <div data-testid={testId}>
            <Input
                title='Last Name'
                placeholder='Type your last name'
                showErrors={showErrors && !currentState}
                onChange={handleChange}
                id={`${baseId}-input-lastName`}
                value={currentState?.toLocaleString() ?? ''}
            />
        </div>
    );
}
